import type { IconProps } from "./icon-types";

/**
 * 눈(eye). 표시/공개, 비밀번호 보기 토글 등에서 [[EyeOffIcon]]과 세트로 사용.
 *
 * VS Code의 `VscEye`(상단 눈꺼풀 아치 + 눈동자 링) 모양을 유지하되, 다른 c6 아이콘
 * (MoonIcon 등)처럼 매끈한 균일 선으로 보이도록 fill이 아닌 stroke로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 24 그리드 / stroke 기반.
 */
export const EyeIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M4 13A8 7.5 0 0 1 20 13" />
    <circle cx="12" cy="13" r="3" />
  </svg>
);
